import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import * as C from '../../../theme/colors.constants';

/**
 * Subseção "Identificação do processo" da aba Histórico (dentro do card
 * "Histórico" — ver `AbaHistorico.jsx`). Layout replica o print de
 * referência da story: caixa cinza-clara com Cliente/Devedor/Responsável/
 * Fase Atual em exibição simples (não `TextField`), seguida do checkbox
 * "Limpar campos".
 *
 * Campos somente leitura, mesma fonte já usada por outras abas
 * (`AbaRecebimento`/`AbaFinanceira`/etc.): `processo.nomeCliente`/
 * `nomeDevedor`/`negociador`/`fase`, já resolvidos pelo mapper
 * (`controleProcessosPage.mapper.js`), sem fetch novo.
 */
function CampoIdentificacao({ label, value }) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 11, fontWeight: 700, color: C.warmGrey, textTransform: 'uppercase', letterSpacing: 0.4,
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color: C.black }}>
        {value || '—'}
      </Typography>
    </Box>
  );
}
CampoIdentificacao.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.string };
CampoIdentificacao.defaultProps = { value: '' };

export default function IdentificacaoProcesso({ processo, limparCamposHistorico, onChangeLimparCamposHistorico }) {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: C.navy, mb: 1 }}>
        Identificação do processo
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          rowGap: 1.5,
          columnGap: 2,
          backgroundColor: C.paleGrey,
          border: `1px solid ${C.borderGrey}`,
          borderRadius: 1.5,
          p: 2,
        }}
      >
        <CampoIdentificacao label="Cliente" value={processo?.nomeCliente} />
        <CampoIdentificacao label="Devedor" value={processo?.nomeDevedor} />
        <CampoIdentificacao label="Responsável" value={processo?.negociador} />
        <CampoIdentificacao label="Fase atual" value={processo?.fase} />
      </Box>

      <FormControlLabel
        sx={{ mt: 1.5 }}
        control={(
          <Checkbox
            size="small"
            checked={limparCamposHistorico}
            onChange={e => onChangeLimparCamposHistorico(e.target.checked)}
          />
        )}
        label={(
          <Typography variant="body2" component="span">
            <Box component="span" sx={{ fontWeight: 700 }}>Limpar campos</Box>
            {' '}
            <Box component="span" sx={{ color: C.warmGrey }}>(padrão ao entrar no processo)</Box>
          </Typography>
        )}
      />
    </Box>
  );
}
IdentificacaoProcesso.propTypes = {
  processo: PropTypes.object,
  limparCamposHistorico: PropTypes.bool.isRequired,
  onChangeLimparCamposHistorico: PropTypes.func.isRequired,
};
IdentificacaoProcesso.defaultProps = {
  processo: null,
};
